import script from "./OnboardingBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingBanner.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingBanner.vue?vue&type=style&index=0&id=a13fe216&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a13fe216"]])

export default __exports__